import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
});

export const styles = {};

export const overrides = {
	'.Pagination-root': {
		'.pageAttribs__items': {
			marginTop: 0,
			padding: remCalc(40),
			gap: remCalc(20),
			borderTop: `1px solid ${getColor('ivory', 600)}`,
			borderBottom: `1px solid ${getColor('ivory', 600)}`,
			[theme.breakpoints.up('md')]: {
				gap: remCalc(40),
			},
			'.pageAttribs__item': {
				minWidth: "5%",
				maxWidth: "25%",
				'&.pageAttribs__item--middle': {
					minWidth: "39%",
				}
			},
		},
		'.Pagination-action': {
			display: 'inline-flex',
			alignItems: 'center',
			gap: remCalc(20),
			border: 'none',
			background: 'transparent',
			padding: 0,
			margin: 0,
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(16),
			fontWeight: 420,
			lineHeight: remCalc(20),
			letterSpacing: '2px',
			textTransform: 'uppercase',
			textDecoration: 'none',
			color: getColor('ivory', 700),
			cursor: 'pointer',
			borderBottom: `1px solid transparent`,
			transition: 'all var(--transition-duration) ease-in',
			'&:hover': {
				color: getColor('ivory', 700),
				borderBottomColor: getColor('ivory', 700),
			},
			'&:focus-visible': {
				outline: 'none',
				borderBottomColor: getColor('ivory', 700),
			},
			'&.Pagination-action--disabled': {
				color: getColor('ivory', 500),
				cursor: 'default',
			},
		},
		'.Pagination-prev, .Pagination-next': {
			whiteSpace: 'nowrap',
		},
		'.Pagination-prevIcon, .Pagination-nextIcon': {
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			'> svg': {
				width: remCalc(10),
				height: remCalc(18),
				fill: 'currentColor',
			},
		},
		'.Pagination-nextIcon > svg': {
			transform: 'rotate(45deg)',
		},
		'.Pagination-prevIcon > svg': {
			transform: 'rotate(-135deg)',
		},
		'.Pagination-pages': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			gap: remCalc(22),
			flexWrap: 'wrap',
			[theme.breakpoints.up('md')]: {
				gap: remCalc(40),
			},
		},
		'.Pagination-page': {
			gap: 0,
			minWidth: remCalc(12),
			justifyContent: 'center',
			color: getColor('ivory', 500),
			'&.Pagination-page--current': {
				color: getColor('ivory', 700),
				textDecoration: 'underline',
				textUnderlineOffset: remCalc(4),
			},
		},
		'.Pagination-page.Pagination-action--disabled': {
			opacity: 1,
		},
		[theme.breakpoints.down('md')]: {
			'.pageAttribs__item--first, .pageAttribs__item--middle, .pageAttribs__item--last': {
				justifyContent: 'center',
			},
			'.Pagination-pages': {
				gap: remCalc(16),
			},
		},
	},
};

export default styles;